export const translations = {
  en: {
    hero: {
      saveDate: "Save the Date",
      and: "&",
      rsvpNow: "RSVP Now",
      details: "Details"
    },
    details: {
      label: "Information",
      title: "Plan Your Journey",
      desc: "We are so excited to celebrate with you in Colombia. Here are some preliminary details to help you start planning your trip.",
      items: [
        {
          title: 'The Destination',
          desc: 'Cartagena, Colombia. A magical colonial city by the Caribbean sea steeped in history and romance.',
          linkText: 'Explore Cartagena'
        },
        {
          title: 'Travel & Visas',
          desc: 'Please ensure your passport is valid. Check your travel and visa requirements below.',
          linkText: 'Check Passport Index'
        },
        {
          title: 'Local Costs',
          desc: 'Cartagena offers options for every budget. View typical costs of living and dining to plan your trip.',
          linkText: 'View Cost Guide'
        },
        {
          title: 'Attire',
          desc: 'Tropical Formal — think elegant, breathable fabrics perfectly suited for the warm Caribbean climate.'
        },
        {
          title: 'Questions?',
          desc: 'Reach out to us directly via WhatsApp or phone:\nBetsi: +1 308-529-0155\nJorge: +34 604-357-524'
        },
        {
          title: 'Registry',
          desc: 'Your presence is the greatest gift. Our formal wedding registry will be available closer to the event.'
        }
      ]
    },
    venue: {
      label: "The Setting",
      title: "The Venue",
      status: "Status: Selection Pending",
      desc: "We are currently hand-selecting a location that captures the romantic essence of Cartagena. We are scouting colonial courtyards with bougainvillea-draped balconies and historic bastions overlooking the Caribbean sea.",
      announcement: "Announcement coming soon",
      quote: "In Cartagena, every stone tells a story of love, and we can't wait to write ours with you."
    },
    rsvp: {
      label: "Join the List",
      title: "Celebrate With Us",
      deadline: "Please RSVP before January 30, 2027",
      desc: "Please complete our official RSVP form to receive travel updates, accommodation details, and your formal invitation.",
      button: "Open RSVP Form",
      redirect: "Redirecting to Google Forms"
    }
  },
  es: {
    hero: {
      saveDate: "Reserva la Fecha",
      and: "&",
      rsvpNow: "Confirma aquí",
      details: "Detalles"
    },
    details: {
      label: "Información",
      title: "Planea tu Viaje",
      desc: "Estamos muy emocionados de celebrar con ustedes en Colombia. Aquí tienen algunos detalles preliminares para ayudarles a planear su viaje.",
      items: [
        {
          title: 'El Destino',
          desc: 'Cartagena, Colombia. Una mágica ciudad colonial a orillas del mar Caribe, impregnada de historia y romance.',
          linkText: 'Explorar Cartagena'
        },
        {
          title: 'Viajes y Visas',
          desc: 'Por favor, asegúrate de que tu pasaporte esté vigente. Consulta los requisitos de viaje y visa a continuación.',
          linkText: 'Consultar Índice de Pasaportes'
        },
        {
          title: 'Costos Locales',
          desc: 'Cartagena ofrece opciones para todos los presupuestos. Consulta los costos típicos para planear tu viaje.',
          linkText: 'Ver Guía de Costos'
        },
        {
          title: 'Vestimenta',
          desc: 'Formal Tropical — telas elegantes y frescas, perfectas para el cálido clima del Caribe.'
        },
        {
          title: '¿Preguntas?',
          desc: 'Contáctanos directamente por WhatsApp o teléfono:\nBetsi: +1 308-529-0155\nJorge: +34 604-357-524'
        },
        {
          title: 'Mesa de Regalos',
          desc: 'Tu presencia es nuestro mejor regalo. Nuestra lista formal de bodas estará disponible más cerca del evento.'
        }
      ]
    },
    venue: {
      label: "El Escenario",
      title: "El Lugar",
      status: "Estado: Selección Pendiente",
      desc: "Actualmente estamos seleccionando un lugar que capture la esencia romántica de Cartagena. Estamos explorando patios coloniales con balcones llenos de buganvilias y baluartes históricos con vista al mar Caribe.",
      announcement: "Anuncio próximamente",
      quote: "En Cartagena, cada piedra cuenta una historia de amor, y no podemos esperar para escribir la nuestra con ustedes."
    },
    rsvp: {
      label: "Acompáñanos",
      title: "Celebra con Nosotros",
      deadline: "Por favor confirma tu asistencia antes del 30 de enero de 2027",
      desc: "Por favor completa nuestro formulario oficial de confirmación para recibir actualizaciones de viaje, detalles de alojamiento y tu invitación formal.",
      button: "Abrir Formulario de Confirmación",
      redirect: "Redirigiendo a Google Forms"
    }
  }
};